import React from 'react';
import FaCalendar from 'react-icons/lib/fa/calendar';

export default class DatePickerWrapper extends React.Component {


    render() {
        return (
            <div className="input-group">
                <input className="datepicker-line-height" type="text"
                    id="datepicker"
                    onChange={this.props.onChange}
                    onClick={this.props.onClick}
                    value={this.props.value} />
                <span onClick={this.props.onClick} className="input-group-addon datepicker-icon">
                    <FaCalendar />
                </span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/DatePickerWrapper.js